import { FC } from "react";
import { useLocation } from "react-router-dom";
import { formatPrice } from "utils/convertNumbThousand";
import logoSrc from "images/bonzah.png";
import { useData } from "data/data-provider";
export interface FleetCardProps {
  className?: string;
  data?: any;
  size?: "default" | "small";
  simpleImg?: boolean;
  onClick?: any;
}

const FleetCard: FC<FleetCardProps> = ({
  size = "default",
  className = "",
  data,
  simpleImg = false,
  onClick,
}) => {
  const {
    fleet_photos,
    name,
    color,
    seats,
    avg_car_price_per_day,
    thumbnail_photo_url,
    allowed_insurances,
    has_bonzah_insurance,
    increased_price,
  } = data!;

  const increasedPriceNum = Number(increased_price);
  const currentPriceNum = Number(avg_car_price_per_day ?? 0);
  const hasDiscount =
    Number.isFinite(increasedPriceNum) &&
    increasedPriceNum > 0 &&
    increasedPriceNum > currentPriceNum &&
    currentPriceNum > 0;
  const discountPercent = hasDiscount
    ? Math.round(((increasedPriceNum - currentPriceNum) / increasedPriceNum) * 100)
    : 0;
  const location = useLocation();
  const { ourCompany } = useData();

  const shouldShowBonzahBadge =
    ourCompany?.show_bonzah_tag === true && has_bonzah_insurance;

  const renderSliderGallery = () => {
    return (
      <div className="relative w-full">
        {(function renderBonzahBadge() {
          if (!shouldShowBonzahBadge) return null;
          return (
            <div className="absolute top-2 left-2 z-10 flex items-center space-x-2 px-2 py-1 rounded-md bg-white bg-opacity-90 shadow">
              <img
                src={logoSrc}
                alt="Bonzah"
                className="w-5 h-5 object-contain"
                onError={(e: any) => {
                  e.currentTarget.style.display = "none";
                }}
              />
              <span className="text-xs font-semibold text-gray-700">Bonzah available</span>
            </div>
          );
        })()}
        {/* {simpleImg ? ( */}
        <img
          src={
            fleet_photos &&
            fleet_photos.length > 0 &&
            thumbnail_photo_url.includes("http")
              ? thumbnail_photo_url
              : fleet_photos && fleet_photos.length > 0
              ? `https://fleet-management-images-upload-be.s3.amazonaws.com/${encodeURIComponent(
                    thumbnail_photo_url,
                  )}`
              : "https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
          }
          alt="name"
          className="h-[200px] object-cover w-full"
        />
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className={size === "default" ? "p-4 space-y-4" : "p-3 space-y-2"}>
        <div className="space-y-2">
          <div className="flex items-center justify-between gap-2">
            <h2
              className={`font-medium capitalize min-w-0 flex-1 ${
                size === "default" ? "text-lg" : "text-base"
              }`}
            >
              <span
                className="block truncate text-text-color whitespace-nowrap overflow-hidden overflow-ellipsis"
                style={{ textOverflow: "ellipsis" }}
              >
                {name}
              </span>
            </h2>
            {hasDiscount && (
              <span className="shrink-0 text-sm font-bold tracking-wide text-button-color">
                {discountPercent}% OFF
              </span>
            )}
          </div>

          <span className="text-text-color text-sm">
            <span className="font-semibold">{seats}</span> seats{" "}
            <span className="font-semibold">{color}</span> color
          </span>
        </div>
        <div className="w-14 border-b border-secondary-100 "></div>
        {avg_car_price_per_day !== 0 && (
          <div className="flex flex-col">
            {hasDiscount && (
              <span className="text-sm font-medium text-secondary-text-color line-through leading-tight">
                {"$" + formatPrice(increasedPriceNum)}
              </span>
            )}
            <span className="text-lg font-bold text-text-color leading-tight">
              {"$" + formatPrice(avg_car_price_per_day ?? 0)}
              {size === "default" && (
                <span className="text-sm text-secondary-text-color font-normal ml-0.5">
                  /day
                </span>
              )}
            </span>
          </div>
        )}
      </div>
    );
  };

  return (
    <div
      className={`nc-StayCard group relative rounded-md border border-secondary-100 overflow-hidden will-change-transform hover:shadow-xl transition-shadow ${className}${
        location.pathname === "/available-car" ? "cursor-pointer" : ""
      }`}
      data-nc-id="StayCard"
      onClick={onClick}
    >
      {renderSliderGallery()}
      {renderContent()}
    </div>
  );
};

export default FleetCard;
